import API from '@/api/callApi.js'
import endpoints from '@/api/endpoints';
export default {
	namespaced : true,
	state : {
		smsEmailHistory: [],
		kpiTrends : [
    		{
    			label : "Inscrits",
    			color : "green",
    			trend : "up",
    			icon : "face",
    			value : 0
    		},
    		{
    			label : "Désinscrits",
    			color : "orange",
    			trend : "down",
    			icon : "face",
    			value : 0
    		},
    		{
    			label : "Total des inscrits",
    			color : "yellow",
    			trend : "even",
    			icon : "face",
    			value : 0
    		}
    	],
    	optInHistory : [
    		{
    			label : "JAN",
    			value : 0
    		},
    		{
    			label : "FÉV",
    			value : 0
    		},
    		{
    			label : "MAR",
    			value : 0
    		},
    		{
    			label : "AVR",
    			value : 0
    		},
    		{
    			label : "MAI",
    			value : 0
    		},
    		{
    			label : "JUI",
    			value : 0
    		},
    		{
    			label : "JUIL",
    			value : 0
    		},
    		{
    			label : "AOÛ",
    			value : 0
    		},
    		{
    			label : "SEP",
    			value : 0
    		},
    		{
    			label : "OCT",
    			value : 0
    		},
    		{
    			label : "NOV",
    			value : 0
    		},
    		{
    			label : "DÉC",
    			value : 0
    		}
    	],
    	categories : [],
    	lastOptInUsersTable : [
    		{
				average_visit_duration : {
					hour : "0",
					minute : "30",
				},
    			nb_visits : '32',
    			segments : [
    				{
    					code : "diner",
    					label : "Dîner",
    					color : "blue"
    				}
    			],
    			optin : true
    		},
    		{
    			average_visit_duration : {
					hour : "1",
					minute : "10",
				},
    			nb_visits : '7',
    			segments : [
    				{
    					code : "morning",
    					label : "Good Morning",
    					color : "green"
    				},
    				{
    					code : "afterwork",
    					label : "Afterwork",
    					color : "purple"
    				}
    			],
    			optin : false
    		},
    		{
				average_visit_duration : {
					hour : "0",
					minute : "45",
				},
    			nb_visits : '28',
    			segments : [
    				{
    					code : "weekend",
    					label : "Weekend",
    					color : "green-dark"
    				},
    				{
    					code : "fidelity",
    					label : "Récompenses Fidélité",
    					color : "pink"
    				}
    			],
    			optin : true
    		},
    		{
				average_visit_duration : {
					hour : "0",
					minute : "45",
				},
    			nb_visits : '29',
    			segments : [
    				{
    					code : "afterwork",
    					label : "Afterwork",
    					color : "purple"
    				},
    				{
    					code : "fidelity",
    					label : "Récompenses Fidélité",
    					color : "pink"
    				}
    			],
    			optin : true
    		},
    		{
				average_visit_duration : {
					hour : "0",
					minute : "45",
				},
    			nb_visits : '18',
    			segments : [
    				{
    					code : "weekend",
    					label : "Weekend",
    					color : "green-dark"
    				},
    				{
    					code : "afterwork",
    					label : "Afterwork",
    					color : "purple"
    				}
    			],
    			optin : true
    		},
			{
    			average_visit_duration : "-",
    			nb_visits : '67',
    			segments : [
    				{
    					code : "weekend",
    					label : "Weekend",
    					color : "green-dark"
    				},
    				{
    					code : "fidelity",
    					label : "Récompenses Fidélité",
    					color : "pink"
    				}
    			],
    			optin : true
    		},
    		{
				average_visit_duration : {
					hour : "0",
					minute : "5",
				},
    			nb_visits : '98',
    			segments : [
    				{
    					code : "afterwork",
    					label : "Afterwork",
    					color : "purple"
    				}
    			],
    			optin : true
    		},
    		{
				average_visit_duration : {
					hour : "0",
					minute : "15",
				},
    			nb_visits : '239',
    			segments : [
    				{
    					code : "weekend",
    					label : "Weekend",
    					color : "green-dark"
    				},
    				{
    					code : "fidelity",
    					label : "Récompenses Fidélité",
    					color : "pink"
    				}
    			],
    			optin : true
    		},
    		{
				average_visit_duration : {
					hour : "0",
					minute : "20",
				},
    			nb_visits : '122',
    			segments : [
    				{
    					code : "midday",
    					label : "Pause Déj",
    					color : "orange"
    				},
    				{
    					code : "fidelity",
    					label : "Récompenses Fidélité",
    					color : "pink"
    				},
    				{
    					code : "diner",
    					label : "Dîner",
    					color : "blue"
    				}
    			],
    			optin : true
    		},
			{
				average_visit_duration : {
					hour : "0",
					minute : "45",
				},
    			nb_visits : '29',
    			segments : [
    				{
    					code : "afterwork",
    					label : "Afterwork",
    					color : "purple"
    				},
    				{
    					code : "fidelity",
    					label : "Récompenses Fidélité",
    					color : "pink"
    				}
    			],
    			optin : true
    		},
    	],
		rightDrawer : {
			frequency : 
				[
					{
						date: "10/01/2020",
						heure: "13h00"
					},
					{
						date: "11/01/2020",
						heure: "17h00"
					},
					{
						date: "11/01/2020",
						heure: "22h00"
					},
					{
						date: "12/01/2020",
						heure: "13h00"
					},
					{
						date: "12/01/2020",
						heure: "21h00"
					},
					{
						date: "13/01/2020",
						heure: "12h45"
					},
					{
						date: "13/01/2020",
						heure: "20h30"
					},
				],
				visits : 
				[
					{
						date: "03/01/2020",
						heure: "10h00"
					},
					{
						date: "01/02/2020",
						heure: "19h00"
					},
					{
						date: "18/02/2020",
						heure: "22h00"
					},
					{
						date: "19/03/2020",
						heure: "13h00"
					},
					{
						date: "01/04/2020",
						heure: "9h00"
					},
					{
						date: "8/04/2020",
						heure: "23h30"
					},
					{
						date: "24/05/2020",
						heure: "13h45"
					},
				],
				history : [
					{
						title : "01h30",
						subtitle : "Temps de présence moyenne"
					},
					{
						title : "25",
						subtitle : "Nombre de passages"
					},
					{
						title : "9",
						subtitle : "Nombre de visites"
					}
				],
			},
    	overviewFilters : {
    		search : null,
    		selectedSegments : []
    	},
	},
	mutations : {
		setKpiTrends (state, { index, value }) {
			state.kpiTrends[index].value = value;
		},
		setDbFilterSearch (state, value) {
			if (value === "") {
				value = null;
			}
			state.overviewFilters.search = value;
		},
		setDbFilterSegments (state, value) {

			let index = state.overviewFilters.selectedSegments.indexOf(value);

			if (index > -1) {
				state.overviewFilters.selectedSegments.splice(index, 1);
			}
			else {
				state.overviewFilters.selectedSegments.push(value);
			}

		},
		increaseMonthInChart(state, month) {
			state.optInHistory[month].value++
		},
		resetChart(state) {
			for (const month of state.optInHistory) {
				month.value = 0
			}
		},
		setSmsEmailHistory(state, data) {
			state.smsEmailHistory = data
		}
	},
	actions : {
		getSmsEmailDashboard({commit}) {
			API.makeGet(endpoints.baseURL + endpoints.endpoints.getDashboardSmsEmailHistory, null, true)
				.then(response => {
				commit('setSmsEmailHistory', response.data.payload);
				});
		}
	}
};